import { VueExtension } from '../../utils/extensions/vue';
import PullRefresh from './pullrefresh.jsx';
import './pullrefresh.scss';

VueExtension.WithInstall(PullRefresh);

export default PullRefresh;
